import { type ReduxUser } from 'models';
import { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnRequestEnterConference } from 'features/events/hooks';
import { isOpenToJoin } from 'features/events/utils';
import { Button, CalendarIcon, CamcorderLineIcon, InviteIcon } from 'ui';
import { type EventTodo } from '../../../../types';
import { BaseTodoWidgetItem } from '../BaseTodoWidgetItem';

type P = {
  type?: ComponentProps<typeof BaseTodoWidgetItem>['type'];
  todo: EventTodo;
  className?: string;
  viewer: ReduxUser;
};

const EventTodoWidgetItem = ({ type, todo, className, viewer }: P) => {
  const { t } = useTranslation();
  const isPending = todo.event.currentUserRsvp === 'pending';

  const { onRequestEnterConference, isJoining } = useOnRequestEnterConference();

  return (
    <BaseTodoWidgetItem
      type={type}
      className={className}
      path={todo.path}
      icon={isPending ? <InviteIcon /> : <CalendarIcon />}
      title={isPending ? t('Respond to event invitation') : t('Join the event')}
      description={todo.event.name}
      additionalDescription={todo.event.textContent}
      startTime={todo.startTime}
      endTime={todo.endTime}
      hasInProgressStatus={todo.event.currentUserRsvp === 'going'}
      items={
        isOpenToJoin(todo.event)
          ? [
              <Button
                type="primary"
                size="small"
                loading={isJoining}
                icon={<CamcorderLineIcon />}
                onClick={(event) => {
                  event.preventDefault();
                  onRequestEnterConference(todo.event, viewer);
                }}
              >
                Join video
              </Button>,
            ]
          : undefined
      }
    />
  );
};

export default EventTodoWidgetItem;
